import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { Ellipses } from '../../../icon/icon-map';
import { PhxTableCellActionItem, PhxTableCellActionMenuItem } from '../../phx-table.types';

/** Kebab trigger with an overflow menu — data-driven via `phxMenuItems` or projected `<phx-menu>`. */
@Component({
  selector: 'phx-table-cell-action',
  templateUrl: './phx-table-cell-action.component.html',
  styleUrls: ['./phx-table-cell-action.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'phx-table-cell-action',
    '(click)': '$event.stopPropagation()',
  },
})
export class PhxTableCellActionComponent {
  /** Data-driven menu items. When omitted, a projected `<phx-menu>` is used. */
  @Input() phxMenuItems: PhxTableCellActionItem[] | undefined;
  /** Disables the trigger button. */
  @Input() phxDisabled: boolean = false;
  /** Emitted when a data-driven menu item is clicked (dividers never emit). */
  @Output() phxMenuItemClick = new EventEmitter<PhxTableCellActionMenuItem>();

  /** Kebab trigger icon. */
  public readonly ellipsesIcon: string = Ellipses;

  /** Type guard for the data-driven menu template. */
  public asMenuItem(item: PhxTableCellActionItem): PhxTableCellActionMenuItem | null {
    return item.isDivider ? null : (item as PhxTableCellActionMenuItem);
  }

  public onItemClick(item: PhxTableCellActionMenuItem): void {
    if (item.disabled) {
      return;
    }
    this.phxMenuItemClick.emit(item);
  }
}
